import React, { memo  } from 'react';
import { Route, Switch } from 'react-router-dom';


import POD from '@/Pages/Public/pod';
import PODDetails from '@/Pages/Public/pod-details';
import Version from '@/Pages/Public/version';

const Routes = () => {
    return (
        <>
            
            <Switch>
                <Route path="/version" exact render={(props) => {
                    return <Version {...props} />
                }} />

                <Route path="/pod-delivery-details/:deliveryId" exact render={(props) => {
                    return <PODDetails {...props} />
                }} />
                <Route path="/" render={props => {
                    return <POD {...props} />
                }} />

            </Switch>
        </>

    );

}

export default memo(Routes);